import { getData } from '../../_helpers/getData';
import React, { useEffect, useState, Component } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Navbar from "./../../components/Navbar";
import TopBar from "./../../components/topbar";
import Footer from "./../../layout/footer";
import constant from '../../_config/constant';


export default function addList(props) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [categoryid, setCategoryid] = useState("");
  const [status, setStatus] = useState("");
  const handleCategoryChange = (e) => {
    console.clear();
    setCategoryid(e.target.value.toString());
  };

  const handleStatusChange = (e) => {
    console.clear();
    setStatus(e.target.value.toString());
  };

  const [datak, setDatak] = useState([]);
  const decoded = getData();

  function onCreatePost(e) {
    const postData = {
      name,
      description,
      categoryid,
      status,
    };

    e.preventDefault();

    axios.post(`/api/subcategory`, postData).then((response) => {
      // props.onPostAdded();
      props.history.push("/subcategory");
    });
  }

  useEffect(() => {
    axios.get("/api/category/").then((todo) => setDatak(todo.data));
  }, []);

  return (
    <div>
      <TopBar user={decoded} title="Add"/>

        <div className="deznav">
          <div className="deznav-scroll">
            <Navbar />
          </div>
        </div>

        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="tab-content">
                  <div className="tab-pane active show" id="All">
                    <form onSubmit={onCreatePost} enctype="multipart/form-data">
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Category
                        </label>
                        <div className="col-sm-10">
                          <select
                            name="categoryid"
                            className="form-select kiselect"
                            onChange={(e) => handleCategoryChange(e)}
                            aria-label="Default select example"
                            required
                          >
                            <option value="">Category</option>
                            {/* {datak.map((property) => (
                              <option value={property._id}>
                                {property.name}
                              </option>
                            ))} */}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Subcategory Name
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="form-control"
                            placeholder="Subcategory Name"
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Description
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="form-control"
                            placeholder="Description"
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Status
                        </label>
                        <div className="col-sm-10">
                          <select
                            name="status"
                            value={status}
                            className="form-select kiselect"
                            onChange={(e) => handleStatusChange(e)}
                            aria-label="Default select example"
                            required
                          >
                            <option value="">status</option>
                            <option value="Active" selected>
                              Active
                            </option>
                            <option value="InActive">InActive</option>
                          </select>
                        </div>
                      </div>

                      <div className="form-group row kimargin">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label"
                        >
                          &nbsp;
                        </label>
                        <div className="col-sm-10">
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
  );
}
